import { relations, sql } from "drizzle-orm";
import { pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { dataRequestTable } from "./dataRequest.js";
import { hdnDossierTable, hdnMessage } from "./hdn.js";
import { agency } from "./main.js";
export const dataRequestValidationTable = pgTable("data_request_validation", {
    hdnMessageId: uuid("hdn_message_id")
        .notNull()
        .unique()
        .references(() => hdnMessage.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    hdnDossierId: uuid("hdn_dossier_id").references(() => hdnDossierTable.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    dataRequestId: uuid("data_request_id")
        .notNull()
        .references(() => dataRequestTable.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    sourceType: text("source_type").notNull(),
    occurredAt: timestamp("occurred_at", {
        withTimezone: true,
        mode: "string",
    }).notNull(),
    type: text("type").notNull().$type(),
    description: text("description"),
    specific: text("specific"),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
});
export const dataRequestValidationRelations = relations(dataRequestValidationTable, ({ one }) => ({
    dataRequest: one(dataRequestTable, {
        fields: [dataRequestValidationTable.dataRequestId],
        references: [dataRequestTable.id],
    }),
    agency: one(agency, {
        fields: [dataRequestValidationTable.agencyId],
        references: [agency.id],
    }),
}));
